import * as React from "react";

import Cookies from "js-cookie";

import Form from "src/common/components/session/Email";

const Domain = ({ children }) => {
  const email = Cookies.get("email");

  const [isMounted, setIsMounted] = React.useState(false);

  React.useEffect(() => {
    setIsMounted(true);
  }, []);

  if (isMounted && !email) {
    return <Form />;
  }

  return children;
};

export default Domain;
